import { render, staticRenderFns } from "./CustomerStat.vue?vue&type=template&id=6132894a&scoped=true&"
import script from "./CustomerStat.vue?vue&type=script&lang=js&"
export * from "./CustomerStat.vue?vue&type=script&lang=js&"
import style0 from "./CustomerStat.vue?vue&type=style&index=0&id=6132894a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6132894a",
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInput,QIcon,QSelect,QSpinner});
